export default function updateViaPointsFromMap(actionContext, val) {
  actionContext.dispatch('updateViaPointsFromMap', val);
}
